import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Stack,
  IconButton,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useScreenSize } from "hooks/useScreenSize";

export const DialogWindow = ({
  open,
  title,
  content,
  actions = null,
  handleClose,
  withCloseButton = false,
  reducedSize = false,
  ...props
}) => {
  const { isMobileWidth } = useScreenSize();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Dialog fullScreen={fullScreen && !reducedSize} open={open} scroll="body" {...props}>
      {withCloseButton && (
        <Stack
          alignItems={"flex-end"}
          sx={{
            margin: 0,
            position: "absolute",
            top: 0,
            right: 0,
          }}
        >
          <IconButton aria-label="close" onClick={handleClose}>
            <CloseIcon fontSize="large" />
          </IconButton>
        </Stack>
      )}
      <DialogTitle>
        <Stack
          justifyContent={"center"}
          alignItems={"center"}
          sx={{
            textAlign: "center",
            fontSize: isMobileWidth ? "16px" : "26px",
          }}
        >
          {title}
        </Stack>
      </DialogTitle>
      <DialogContent sx={{ minWidth: "300px" }}>{content}</DialogContent>
      <DialogActions
        sx={{ margin: 1, justifyContent: "center", alignItems: "center" }}
      >
        {actions}
      </DialogActions>
    </Dialog>
  );
};
